<!--
  El editor de Formularios
-->
<!-- Definiciones - Informacion -->
<div class="page" id="record-def-page">
	<div class="action-bar dark-bg with-tabs">
		<!-- div class="title no-margin">Formulario</div -->
        <div class="title"></div>
        <div class="tabs">
            <!-- <a class="tab">Info</a>       
            <a class="tab selected" href="#">Diseño</a>       
            <a class="tab">Presentación</a>       
            <a class="tab">Permisos</a>       
            <a class="tab">Colores</a>       
            <a class="tab">Reglas y ...</a>       -->
            <span class="tabs-breadcrumbs">
                <a href="#" class="account-full-name">Cuenta</a> /
                <a href="#" class="profile-full-name">Persona</a> /
                Formularios
            </span>
        </div>
		<div class="actions-set">
            <a class="action-btn back CancelBtn" href="#formularios?estado=E" title="Cancelar"></a>
            <a class="action-btn add AddComponentsBtn" href="#" title="Agregar elementos al formulario"></a>
            <a class="hidden action-btn device EmulatorBtn" href="#" title="Abrir emulador"></a>
            <!-- <a class="action-btn save SaveBtn" href="#" title="Guardar y continuar ..."></a> -->
            <a class="action-btn done SaveExitBtn" href="#" title="Guardar y Salir"></a>
            &nbsp;|&nbsp;
            <a class="action-btn more MoreBtn" href="#"></a>
            <a class="action-btn sos" href="#">SOS</a>      
        </div>
            <!-- 
            -->
	</div>
	<div class="content">
        <div class="sidebar hidden">
            <div class="pane">
                <a href="#definir-info" class="tab">Información Gral.</a>
                <p>Aquí puedes modificar la información general, tal como título, descripción,
                estado y permisos del registro.</p>
            </div>
            <div class="pane on-edition">
                <a href="#definir-formulario" class="tab">Diseño del Formulario</a>
                <p>Aquí puedes armar tu propio formulario, con sus secciones, campos
                y otras varias opciones.</p>
            </div>
            <div class="pane on-edition">
                <a href="#definir-presentacion" class="tab">Presentación</a>
                <p>Permite definir el modo como deseas que se presente la información
                del registro.</p>
            </div>
        </div>
      <div class="container">
        <div class="section explains" id="definir-intro">
            <table>
                <tr>
                    <td>
                        <p class="note">
                        Ya puedes diseñar tus propio formulario para este registro, para ello haz click en
                        <a class="tab" href="#formulario-tipo">Diseñar el formulario</a>.
                        </p>
                        <p class="note">
                        Este formulario será usado por las personas que tu autorizes.
                        Cuando ellos sincronizen sus dispositivos, el nuevo formulario
                        se agregara a la lista de registros que pueden crear o revisar.
                        </p>
                        <p class="note">
                        Recuerda que debes publicar el formulario para que ellos puedan
                        usarlo.
                        </p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p class="note">
                        También puedes indicar como deben mostrarse los registros recolectados,
                        para ello haz click en
                        <a class="tab" href="#presentacion-tipo">Presentación</a>.
                        </p>
                        <p class="note">
                        Esto permite definir que campos y columnas del registro deseas mostrar
                        en el tablero de control, por que campos puede agruparse este registro,
                        y otras opciones de presentación muy útiles cuando deseas ver
                        la información existente.
                        </p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p class="note">
                        O puedes modificar la información general de este registro,
                        para ello haz click en
                        <a class="tab" href="#info-tipo">Modificar su información</a>.
                        </p>
                        <p class="note">
                        Aquí puedes modificar el titulo o la descripción, cambiar su estado
                        y también
                        quienes pueden (o no pueden) hacer ciertas cosas sobre el registro tales como editar y revisar.
                        </p>
                        <p class="note">
                        Si eres una empresa que cumple (o desea cumplir) normas y regulaciones, aquí tambien
                        encontraras opciones útiles para cumplir con esos requerimientos, tales como definir
                        el codigo único y el tiempo de resguardo de estos registros.
                        </p>
                    </td>
                </tr>
            </table>
        </div><!-- section -->

		<div class="section" id="definir-info">
			<form>
                     <h3>Identificación del registro</h3>
                     <ul>
                             <li class="StringCtrl required" property="title">
                                 <label>Nombre <b >*</b></label>
                                 <input  class="big" type="text" size="40" name="name"/>
                             </li>
                             <li class="TextCtrl required" property="descr">
                                 <label>Descripción</label>
                                 <textarea  class="big" rows="5" cols="40" name="descr"></textarea>
                             </li>
                             <li class="StringCtrl" property="version">
                                 <label>Versión</label>
                                 <input  class="big" type="text" size="10" name="version" disabled="disabled"/>
                             </li>
                             <li class="SelectCtrl" property="state">
                                 <label>Estado</label>
                                 <select></select>
                             </li>
                             <li class="StringCtrl hidden" property="tags"><input value=""/></li>
                             <li class="StringCtrl hidden" property="prefix"><input value=""/></li>
                             <li class="TextCtrl hidden" property="form"><textarea></textarea></li>
                             <li class="TextCtrl hidden" property="data"><textarea></textarea></li>
                     </ul>
                    <h3>Actividades y permisos</h3>
                    <ul>
                        <li class="MultiSelectCtrl" property="roles_init">
                            <label>Crear</label>
                            <select></select>
                            <p class="options hint"></p>
                        </li>
                        <li class="MultiSelectCtrl" property="roles_edit">
                            <label>Llenar</label>
                            <select></select>
                            <p class="options hint"></p>
                        </li>
                        <li class="MultiSelectCtrl" property="roles_review">
                            <label>Revisar</label>
                            <select></select>
                            <p class="options hint"></p>
                        </li>
                        <li class="MultiSelectCtrl" property="roles_view">
                            <label>Ver</label>
                            <select></select>
                            <p class="options hint"></p>
                        </li>
				    </ul>
                    <p class="note">
                    Aquí se indica que roles pueden realizar cada una de estas actividades.
                    <br/>Solamente las personas que tengan alguno de los roles indicados las podrán
                    llevar a cabo.
                    </p>
                     <p class="center">
                             <button class="accept SaveBtn big"> Guardar cambios</button>
                             <button class="version VersionBtn big"> Nueva versión</button>
                             <button class="cancel CancelBtn big"  href="#definidos?state=E"> Cancelar</button>
                     </p>
			</form>
		</div><!-- section -->

        <div class="section" id="formulario">
            <div class="form-editor">
                    <div class="device-emulator-contexts">
                        <div class="context" name="is-empty">
                            <img class="pointer" src="img/extras/pointer-left.png"/>
                            <img class="flecha" src="img/pruebas/ayuda-formulario-vacio.png"/>
                            <br/>
                                <h3 style="font-family: cursive;font-size: 29px;font-style: italic;">Mmmm ... todavía esta vacío</h3>
                                <p>
                                Puedes comenzar agregando una nueva sección al formulario. Elige alguna de las variantes:
                                </p>
                            <p class="indented">
                                <a class="add-section-btn" icon="panel-icon">
                                    <br>Panel
                                </a>
                                &nbsp;
                                <a class="add-section-btn" icon="table-icon">
                                    <br>Tabla
                                </a>
                                &nbsp;
                                <a class="add-section-btn" icon="list-icon"><br>Lista
                                </a>
                                &nbsp;&nbsp;
                                <a class="add-section-btn" icon="paragraph-icon">
                                    <br>Párrafo
                                </a>
                                &nbsp;
                                </p>
                            <p class="hint">
                                Simplemente <b>clickea</b> en la variante elegida o bien <b>arrástrala</b> al interior del formulario en la posición deseada.</p>
                            <p>
                                &raquo; <a class="aside">Que es una sección ?</a>
                                <br>&raquo; <a class="aside">Por qué hay diferentes variantes ?</a>
                                <br>&raquo; <a class="aside">Aún necesitas ayuda ?</a>
                            </p>
                            <br>
                        </div>
                        <div class="context" name="x-not-empty">
                            <img class="flecha" src="img/pruebas/ayuda-formulario-vacio.png"/>
                            <img class="pointer" src="img/extras/pointer-left.png"/>
                            <br/>
                            <h3 style="font-family: cursive;font-size: 24px;font-style: italic;">Sección <a style="font-size:18px;">Datos del cliente</a> seleccionada</h3>
                            <br>
                            <p>Puedes agregar un 
                                &nbsp;
                                <a class="small add-field-btn">Campo</a> 
                                <a class="small-add-field-btn"> Acción </a>
                                <a class="small-add-field-btn"> Módulo </a>
                            </p>
                            <p>O una sección 
                                &nbsp;
                                <a class="small-add-section-btn">Panel</a>
                                <a class="small-add-section-btn">Tabla</a>
                                <a class="small-add-section-btn">Lista</a>
                                <a class="small-add-section-btn">Párrafo</a>
                            </p>
                            <p class="hidden">
                                <a class="add-field-btn" icon="text-icon"><br/>Texto</a>
                                <a class="add-field-btn" icon="number-icon"><br/>Número</a>
                                <a class="add-field-btn" icon="date-icon"><br/>Fecha</a>
                                <a class="add-field-btn" icon="time-icon"><br/>Hora</a>
                                <a class="add-field-btn" icon="check-icon"><br/>Tilde</a>
                                <a class="add-field-btn" icon="options-icon"><br/>Opciones</a>
                                <a class="add-field-btn" icon="item-icon"><br/>Item</a>
                                <a class="add-field-btn" icon="qrcode-icon"><br/>Código</a>
                                <a class="add-field-btn" icon="photos-icon"><br/>Fotos</a>
                                <a class="add-field-btn" icon="image-icon"><br/>Imagen</a>
                                <a class="add-field-btn" icon="attachs-icon"><br/>Adjuntos</a>
                                <a class="add-field-btn" icon="gps-icon"><br/>GPS</a>
                                <a class="add-field-btn" icon="calculate-icon"><br/>Cálculo</a>
                                <a class="add-field-btn" icon="graph-icon"><br/>Gráfico</a>
                            </p>
                            <p><b>Clickea</b> el encabezado de la sección o uno de los campos para modificar las opciones del mismo.</p>
                            <p>Las otras secciones (no seleccionadas) son:
                                <a>Contactos</a> | <a>Plantas</a> | <a>Equipos</a></p>
                            <br>
                            <p>
                                <a class="aside">Aún necesitas ayuda ?</a>
                            </p>
                            <br>
                        </div>
                        <div class="context" name="not-empty">
                            <img class="flecha" src="img/pruebas/ayuda-formulario-vacio.png"/>
                            <img class="pointer" src="img/extras/pointer-left.png"/>
                            <br/>
                            <h3 style="font-family: cursive;font-size: 29px;font-style: italic;">Agrega un campo ...</h3>
                            <br>
                            <p>
                                <a class="add-field-btn" icon="text-icon"><br/>Texto</a>
                                <a class="add-field-btn" icon="number-icon"><br/>Número</a>
                                <a class="add-field-btn" icon="date-icon"><br/>Fecha</a>
                                <a class="add-field-btn" icon="time-icon"><br/>Hora</a>
                                <a class="add-field-btn" icon="check-icon"><br/>Tilde</a>
                                <a class="add-field-btn" icon="options-icon"><br/>Opciones</a>
                                <a class="add-field-btn" icon="item-icon"><br/>Item</a>
                                <a class="add-field-btn" icon="qrcode-icon"><br/>Código</a>
                                <a class="add-field-btn" icon="photos-icon"><br/>Fotos</a>
                                <a class="add-field-btn" icon="image-icon"><br/>Imagen</a>
                                <a class="add-field-btn" icon="attachs-icon"><br/>Adjuntos</a>
                                <a class="add-field-btn" icon="gps-icon"><br/>GPS</a>
                                <a class="add-field-btn" icon="calculate-icon"><br/>Cálculo</a>
                                <a class="add-field-btn" icon="graph-icon"><br/>Gráfico</a>
                                <br>
                                <span class="hidden">Simplemente <b>clickea</b> en la variante elegida o bien <b>arrástrala</b> al interior del formulario en la posición deseada.</span>
                                </p>
                            <p>
                                <a class="add-field-btn" icon="add"><br>Acciónes</a>
                                <a class="add-field-btn" icon="add"><br>Módulos</a>
                                <a class="add-section-btn" icon="add"><br>Secciónes</a>
                                </p>
                            <p class="hidden">Las otras secciones (no seleccionadas) son:
                                <a>Contactos</a> | <a>Plantas</a> | <a>Equipos</a></p>
                            <br>
                            <p>
                                &raquo; <a class="aside">Que es un campo ?</a>
                                &nbsp; <a class="aside">Una acción ?</a>
                                &nbsp; <a class="aside">Un módulo?</a>
                                <br>&raquo; <a class="aside">Cómo lo agrego al formulario ?</a>
                                <br>&raquo; <a class="aside">Aún necesitas ayuda ?</a>
                            </p>
                            <br>
                        </div>
                    </div>
                    <div class="device-emulator tablet7 portrait">
                            <b style="color:lime;position: absolute;top: 18px;left: 30px;">o</b>
                            <b style="color:#fff;position: absolute;top: 18px;left: 45px;">||||</b>
                            <b style="color: #dedede;;position: absolute;top: 18px;left: 195px;">|||||||||||||||||||||||||||||||||</b>
                            <b style="color: #dedede;position: absolute;top: 12px;left: 442px;font-size: 22px;">O</b>
                            <div class="device-display">
                                <div class="page-header">
                                    <span class="title">Título del formulario va aquí ...</span>
                                </div>
                                <div class="page-content empty">
                                    <div class="empty center">
                                        <br><br>
                                        <a class="add-section-btn big" icon="grid-icon" href="#">
                                            <br/>Bienvenida 
                                        </a>
                                        <br><br>
                                        <a class="add-section-btn big" icon="add" href="#">
                                            <br/>Agrega una primera sección a este formulario 
                                        </a>
                                        <br><br>
                                        <a class="add-section-btn big" icon="grid-icon" href="#">
                                            <br/>Despedida 
                                        </a>
                                    </div>
                                    <div class="container also">
                                        <form class="ui-sortable dynamic"></form>
										<hr/>
										<div class="filler" style="height:100em"></div>
                                    </div>
                                </div>
                            </div>
                            <!--<div class="device-btns">O</div>-->
                    </div>
            </div>
        </div><!-- section -->

        <div class="section splitted" id="definir-presentacion">
            <div class="left-split">
                <br/>
                <h2>Como mostrar estos registros</h2>
                <form>
                <ul>
                    <li class="required">
                        <label>Título <b>*</b></label>
                        <span class="StringCtrl" property="title">
                            <input class="big" type="text" size="30" value=""/>
                        </span>
                        <p>
                            Este es el título con que se identificará el registro.
                        </p>
                    </li>
                    <li>
                        <label>Descripción</label>
                        <span class="TextCtrl" property="descr">
                            <textarea cols="36" rows="2" value=""></textarea>
                        </span>
                        <p>
                            Esto aporta información adicional del registro (como por ej.
                            el total de la compra, u otros campos que muestren
                            rápidamente información importante).
                        </p>
                    </li>
                    <li>
                        <label>Status</label>
                        <span class="StringCtrl" property="bubble">
                           <input class="big" type="text" size="20" value=""/>
                        </span>
                        <p>
                            Estado de este registro.
                        </p>
                    </li>
                    <li class="hidden">
                        <p class="big">
                            <button class="add dark float-right AddColumnBtn" name="columns"></button>
                            Utilizando el botón, puedes agregar una o mas columnas a la
                            presentación en formato de tabla. También puedes cambiar o eliminar las
                            columnas agregadas.
                        </p>
                        <p>&nbsp;</p>
                        <div class="rowr">
                            <table class="additional-cols">
                                <tr></tr>
                            </table>
                        </div>
                    </li>
                </ul>
                </form>

               <form id="templates" action="" method="POST">
                   <br/>
                   <h2>Plantillas</h2>
                   <ul>
                       <li>
                           <p class="big" >
                               <b>Word (Docx): </b>
                               &nbsp;
                               <a href="#" class="external" target="_blank" id="definir-docx-basic-template-btn">Bajar plantilla básica</a>
                               &nbsp; | &nbsp;
                               <a href="#" class="external" target="_blank" id="definir-docx-active-template-btn">Bajar plantilla en uso</a>
                               &nbsp; | &nbsp;
                               <a href="#" class="external" target="_blank" id="definir-docx-upload-btn">Subir una plantilla</a>
                           </p>
                       </li>
                   </ul>
                   <ul>
                       <li>
                           <p class="big" >
                               <b>Excell (Xlsx): </b>
                               &nbsp;
                               <a href="#" class="external" target="_blank" id="definir-xlsx-basic-template-btn">Bajar plantilla básica</a>
                               &nbsp; | &nbsp;
                               <a href="#" class="external" target="_blank" id="definir-xlsx-active-template-btn">Bajar plantilla en uso</a>
                               &nbsp; | &nbsp;
                               <a href="#" class="external" target="_blank" id="definir-xlsx-upload-btn">Subir una plantilla</a>
                           </p>
                       </li>
                   </ul>
               </form>

            </div> <!-- left-split -->
            <div class="right-split">
                <h3>Presentación en una lista</h3>
                <img src="img/extras/presentacion-ejemplo1.png" width="260px;"/>
                <p>
                       Para definir el título, descripción y status, es posible utilizar uno (o más)
                       campos del formulario dentro del
                       texto. Estos serán reemplazados por sus valores al momento
                       de guardarse los datos.
                </p>
                <p>&nbsp;</p>
                <p>
                       Se respetan los saltos de linea,
                       y se pueden usarse microformatos. Más info en
                       <a href="/faq.html?q=microformatos" target="_blank">Que son los microformatos ?</a>
                </p>
                <p>&nbsp;</p>
                <div class="hidden">
                <h3>Presentación en una tabla</h3>
                <img src="img/extras/presentacion-ejemplo2.png" width="260px;"/>
                <p>Puedes definir que campos del registro son más importantes, para el momento
                en que analizes los datos y necesites presentarlos en formato de tabla.</p>
                <p>&nbsp;</p>
                <p>Para definir cada columna, es posible utilizar uno (o más)
                       campos del formulario dentro del
                       texto. Estos serán reemplazados por sus valores al momento
                       de guardarse los datos.
                </p>
                </div>
            </div>
        </div><!-- section -->

      </div><!-- container -->
	</div><!-- content -->
</div>

<ImportDialog />

<!--  los dialogos Popup DEBEN ir aqui: AFUERA de .page
  de otro modo pueden quedar cortados por otros elementos
-->

<div id="upload-templates-pop" class="lower-pop-dialog right">
   <span class="moving-pointer">&nbsp;</span>
   <div style="">
     <h3 class="title">Archivo Word o Excell para usar como plantilla</h3>
     <form style="no-overflow-y:auto;width:40em;"
     id="templates-uploader" action="" method="POST">
     <fieldset class="xcontent">
                 <input type="FILE" name="file_data" class="files"/>&nbsp;
                </fieldset>
                <hr/>
                <fieldset class="right">
                  <button class="medium" id="templates-uploader-btn">Subir !</button>
            </fieldset>
          </form>
          <div id="upload-templates-result" class="hidden">Resultado ...</div>
   </div>
  </div>
  
  <div id="editables-pop" class="lower-pop-dialog as-right-drawer"> 
    <img class="pointer" src="img/extras/pointer-left.png"/>
    <div>
      <h3 class="title"></h3>
      <form class="">
        <fieldset class="xcontent"></fieldset>
        <fieldset class="xfooter">
          <a class="hidden"
          style="padding: 0.8em 0 0 0;margin-top: 0em;display: none;inline-block;float: left;font-size: 1.2em;"
          href="">Opciones avanzadas ...</a>
          <button class="accept ApplyBtn"></button>
          <button class="delete DeleteBtn"></button>
          <button class="cancel CancelBtn"></button>
        </fieldset>
      </form>
      <h3 class="debug" style="display:none"></h3>
    </div>
  </div>
  
  <div id="vars-list-pop" class="lower-pop-dialog right">
    <span class="moving-pointer">&nbsp;</span>
    <div style="">
      <ul style="no-overflow-y:auto;width:260px;" id="vars-list"></ul>
    </div>
  </div>
  
  
  <!--
    Templates
  -->
  <div class="hidden" id="record-def-templates">
    
    <div id="record-def-properties-dialog-template" class="conversation-dialog">
      <form>
            <div>
              <a class="dialog-btn" name="CloseBtn" icon="close"></a>
                <h3>
                  Formulario &nbsp;
                  <input name="title" type="text" value="" placeholder="Nombre ?" style="width:22em;">
                </h3>
                <p>
                  Es la versión
                  <input name="version" type="number" value="" placeholder="" style="width:4em;"/>
                  &nbsp; y está &nbsp;
                  <select name="state">
                    <option value="A">Vigente</option>
                    <option value="I">Inactiva</option>
                    <option value="E">En edición</option>
                    <option value="X">Eliminada</option>
                  </select>.
                </p>
                <p>
                  Se usará el alias <input name="alias" type="text" value="" placeholder="" style="width:16em;"/> para referirse a este formulario.
                </p>
                <p>
                  <textarea  style="width:35em;" rows="3" name="descr" placeholder="Breve descripción del formulario"></textarea>
                </p>
                <p>
                  Su IDN <input name="id" type="text" disabled="disabled" style="width:20em;"/>
                </p>
                <hr/>
                <p class="dialog-buttons">
                  <a class="dialog-btn" icon="accept" name="CreateBtn"> &nbsp;CREARLO AHORA !</a>
                    <a class="dialog-btn" icon="accept" name="UpdateBtn"> &nbsp;GUARDAR AHORA !</a>
                  </p>
                </div>
              </form>
            </div>

            <div id="record-def-permissions-dialog-template" class="conversation-dialog">
              <form>
                <div>
                  <a class="dialog-btn" name="CloseBtn" icon="close"></a>
                  <h2>Quienes pueden ...</h2>
                  <p>
                    Crear 
                    <span name="roles_init" class="options-container">
                      <span class="options"></span>
                      <select name="role-add-btn">
                        <option value="-1">+</option>
                      </select>
                    </span>
                  </p>
                  <p>
					Completar
          <span name="roles_edit" class="options-container">
            <span class="options"></span>
                        <select name="role-add-btn">
                            <option value="-1">+</option>
                          </select>
                        </span>
                </p>
                <p>
                  Revisar
                  <span name="roles_review" class="options-container">
                    <span class="options"></span>
                    <select name="role-add-btn">
                      <option value="-1">+</option>
                    </select>
                  </span>
                </p>
                <p>
                  Ver
                  <span name="roles_view" class="options-container">
                        <span class="options"></span>
                        <select name="role-add-btn">
                          <option value="-1">+</option>
                        </select>
                      </span>
                    </p>
                <hr/>
                <p class="dialog-buttons">
                  <a class="dialog-btn" icon="accept" name="UpdateBtn"> &nbsp;GUARDAR AHORA !</a>
                </p>
              </div>
        </form>
      </div>
      
    <div id="record-def-views-dialog-template" class="conversation-dialog">
      <form>
            <div>
              <a class="dialog-btn" name="CloseBtn" icon="close"></a>
              <h2>
                Opciones de presentación
              </h2>
              <p>
                Describa aquí como se armarán el <b>Encabezado</b>, 
                <b>Título</b>, y <b>Descripción</b> de este registro. 
                Se pueden incluir dentro de los mismos campos del formulario,
                como por ejemplo <i>#texto_4</i>.
              </p>
              <p>
                Encabezado <input 
                name="bubble" 
                type="text" 
                style="width:30em;"/>
              </p>
              <p>
                Título <input 
                name="title" 
                type="text" 
                value="" 
                placeholder="" 
                style="width:30em;"/>
              </p>
              <p>
                Descripción
                <textarea  
                name="descr" 
                style="width:35em;" 
                rows="3"
                placeholder="Breve descripción del formulario"></textarea>
              </p>
              <hr/>
              <p class="dialog-buttons">
                <a class="dialog-btn" icon="accept" name="UpdateBtn"> &nbsp;GUARDAR AHORA !</a>
              </p>
            </div>
          </form>
        </div>
        
        <div id="record-def-drawer-template">
          <form>
            <div class="drawer-right">
              <div class="drawer-item">
                <button id="record-def-properties-btn" icon="info-icon">Propiedades</button>
                <br>
                <button id="record-def-permissions-btn" icon="permissions-icon">Permisos</button>
                <br>
                <button id="record-def-presentation-btn" icon="presentation-icon">Presentación</button>
              </div>
              <hr/>
              <div class="drawer-item">
                    <button id="record-def-change-state-A-btn" icon="start">Poner vigente !</button>
                    <button id="record-def-change-state-E-btn" icon="edit">Pasar a Edición !</button>
                    <button id="record-def-change-state-I-btn" icon="stopped">Pasar a Inactivo !</button>
                  </div>
                  <hr/>
                <div class="drawer-item">
                  <button id="record-def-new-version-btn" icon="version-icon">Nueva versión ...</button>
                  <button id="record-def-export-btn" icon="export">Exportar ...</button>
                  <button id="record-def-import-btn" icon="import">Importar ...</button>
                  <button id="record-def-qr-labels-gen-btn" icon="qrcode-icon">Generar códigos QR</button>
                </div>
                <hr/>
                <div class="drawer-item">
                  <button id="record-def-remove-btn" icon="delete">Eliminarlo ...</button>
                </div>
            </div>
          </form>
    </div>
    
    <div id="form-editor-tools" class="lower-pop-dialog on-action-bar" style="width:460px;">
      <FormEditorToolsPanel />
    </div>

    <div id="field-dialog-templates" style="display:none;">
      <FieldDialogs />
    </div>
    
  </div>
  <TicketTemplateDialog />
  <QrLabelDialog />
  
  <script>
  import { onMount } from 'svelte'
  import FormEditorToolsPanel from './blocks/FormEditorToolsPanel.svelte';
  import FieldDialogs from './blocks/FieldDialogs.svelte'
  import ImportDialog from './blocks/ImportDialog.svelte'
  import TicketTemplateDialog from './blocks/TicketTemplateDialog.svelte'
  import QrLabelDialog from './blocks/QrLabelDialog.svelte';
  
  onMount(() => {
    window.$("#record-def-page").RecordDefPage("#formulario");
    console.log("DONE: installed RecordDefPage to hash '#formulario'")
  })
</script>
